var exports = {
  "yZ": "xdde3148b--b8ef3d--collapsed",
  "lu": "xdde3148b--b8ef3d--expandable",
  "x6": "xdde3148b--b8ef3d--button",
  "Qp": "xdde3148b--b8ef3d--inline-text",
};

module.exports = exports;
